import { createUseStyles } from 'react-jss';

const styles = {
  filterBar: {
    '& ui5-label': {
      marginBottom: '0.3rem'
    },
    '& > div > :last-child > div': {
      marginRight: '0 !important'
    }
  },
  helpCursor: {
    cursor: 'help'
  },
  filterGroupItem: {
    minWidth: '17rem'
  },
  filterItem: {
    minWidth: '15rem',
    flexGrow: '1'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'Filters'
});
